<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Marvin Dixon’s debut novel, <em>Settlement</em>, was published in 2019 inspired by his experiences in the world of financial services. Thus began the story of Justin Kell a financial journalist and private investigator with a passion for ensuring justice is done. <em>Payback</em> (2021) and <em>Redemption</em> (2022) continued Kell’s story with <em>Brotherly Love</em> being the fourth in the series.</p><br/>
<p style="text-indent:00em;">Now retired from financial services and focussing on his writing, Marvin Dixon lives in West Yorkshire.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5389cb33